import React, { useMemo } from 'react'
import TicketDetailsListItem from './TicketDetailsListItem'
import { MwSpinnerButton } from '../ui'
import { useCurrent } from '../../hooks'

const TicketDetailsList = ({ data, loading, ticket, onRefresh }) => {
    const { currentLangId } = useCurrent();
    const visibleDetails = useMemo(() => {
        const rows = Array.isArray(data) ? data : [];
        return rows.filter((item) => {
            if (item?.isInternal === true) return false;
            const visibility = String(item?.visibility || 'external').toLowerCase().trim();
            return visibility !== 'internal';
        });
    }, [data]);

    return (
        <>
            {
                loading ? <MwSpinnerButton isFullCenter={true} withLabel={false} /> :
                    <div className='bg-white p-6 rounded-2xl shadow-sm border border-slate-100'>
                        <div className='pb-4 text-sm font-bold text-slate-700'>
                            {currentLangId === 'ar' ? 'الردود والمحادثة' : 'Replies and Conversation'}
                        </div>
                        {
                            visibleDetails.length > 0 ? visibleDetails.map((item) => (
                                <TicketDetailsListItem
                                    key={item._id}
                                    item={item}
                                    ticket={ticket}
                                    onRefresh={onRefresh}
                                />
                            )) : (
                                <div className='text-sm text-slate-400 py-4'>
                                    {currentLangId === 'ar' ? 'لا توجد ردود حتى الآن' : 'No replies yet'}
                                </div>
                            )
                        }
                    </div>
            }
        </>
    )
}

export default TicketDetailsList
